var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-1",modifiers:{"modal-1":true}}]},[_vm._v("Privacy Statement")]),_c('b-modal',{attrs:{"id":"modal-1","size":"xl","title":"Privacy Policy"}},[_c('appPrivacyPolicy')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }